module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBdItalic.eot?v=0a187a9b7618f90c6f1e296e08d08dee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBdItalic.eot?
// module id = 677
// module chunks = 0